.results {
  height: 400px;
  padding-top: 0.5rem;
  overflow-y: auto;
  border-top: 1px solid var(--gray-400);
}

.input input {
  padding-right: 0;
  padding-left: 0;
  background-color: transparent;
  border: none;
}

.cap {
  padding: 0 0.75rem;
  padding-top: 1rem;
}
